import React from "react";
import PropTypes from "prop-types";
import { connect } from "formik";
import MuiDateAndTimeField from "venuescanner-js/react/components/MuiFields/MuiDateAndTimeField";
import initialEventDetailsClasses from "../../styles/initialEventDetails.module.scss";

const TimeComponent = ({ className, ...props }) => (
  <select className={[initialEventDetailsClasses.TimeInput]} {...props} />
);
TimeComponent.propTypes = {
  className: PropTypes.string,
};

export default connect(({ formik }) => (
  <MuiDateAndTimeField
    date={{ start: formik.values.start_date, end: formik.values.end_date }}
    time={{ start: formik.values.start_time, end: formik.values.end_time }}
    onChangeDate={({ start, end, singleDay }) => {
      formik.setFieldValue("start_date", start);
      formik.setFieldValue("end_date", end);
      formik.setFieldValue("single_day", singleDay);
    }}
    onChangeTime={(value) => {
      if (value.start !== formik.values.start_date) {
        window.dataLayer.push({ event: "startDate" });
        formik.setFieldValue("start_time", value.start);
      }

      if (value.end !== formik.values.end_date) {
        window.dataLayer.push({ event: "endDate" });
        formik.setFieldValue("end_time", value.end);
      }
    }}
    disabled={formik.isSubmitting}
    endError={formik.errors.end_time}
    extraTimeProps={{
      start: {
        "data-ga": "startTime",
      },
      end: {
        "data-ga": "endTime",
      },
    }}
    TimeComponent={TimeComponent}
  />
));
